import React from 'react';
import { observer } from 'mobx-react-lite';
import { colors } from '@insurancemenu/imenu-components-lib';

import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useAddQuotePageStore } from 'store/pages/quote/add-quote/pageStore';
import { AddPlanButtonStyled, ProductLineHeaderRowStyled, ProductLineTitleStyled } from './styles';
import { ADD_QUOTE_TEST_IDS } from '../../constants';

interface Props {
  productLineId: ProductLineId;
}

const AddQuoteProductLineHeader: React.FC<Props> = observer(({ productLineId }) => {
  const { onAddPlan, canAddPlan } = useAddQuotePageStore();

  return (
    <ProductLineHeaderRowStyled>
      <ProductLineTitleStyled productLineId={productLineId} />
      {canAddPlan(productLineId) && (
        <AddPlanButtonStyled
          color="custom"
          customColor={colors.green[600]}
          size="large"
          uppercase
          leftIconProp={<Add />}
          data-test-id={ADD_QUOTE_TEST_IDS.ADD_PLAN_BUTTON}
          onClick={() => onAddPlan(productLineId)}
        >
          Add Plan
        </AddPlanButtonStyled>
      )}
    </ProductLineHeaderRowStyled>
  );
});

export default AddQuoteProductLineHeader;
